<template>
    <div class="foot">
        <div class="footItem">
            <div class="top">
                <span>---------------</span>
                <span v-for="(item, index) in chunkList" :key="index">
                    <span class="chunk" @click="jump(item, index)">{{item.name}}</span>
                    <span>-</span>
                </span>
                <span>---------------</span>
            </div>
            <!-- <div class="center"></div> -->
            <div class="bottom">
                <div>
                    <span>版权所有：企业信用建设服务平台</span>
                    <span style="margin-left: 15px;">共建单位：中国企业改革与发展研究会信用工作委员会、中国合作贸易企业协会信用合规专业委员会</span>
                </div>
                <div style="margin-top: 5px;">
                    <span>运营维护：国信标准（北京）信用评价中心</span>
                    <span style="margin-left: 15px;">技术支持：江苏同袍信息科技有限公司</span>
                </div>
                <div style="margin-top: 5px;">
                    <span>地址：北京市朝阳区东三环南路96号院</span>
                    <span style="margin-left: 10px;">邮编：100122</span>
                    <span style="margin-left: 10px;">电子信箱：zgcx2008@126.com</span>
                    <span style="margin-left: 10px;text-decoration: underline;cursor: pointer;" @click="toBeian">京ICP备2024065964号<a href="https://beian.miit.gov.cn/#/Integrated/index"></a></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'foot',
    data() {
        return {
            chunkList: [
                {
                    name: '关于我们',
                    routeName: 'withUs',
                    active: 0
                },
                {
                    name: '网站介绍',
                    routeName: 'webIntroduce',
                    active: 0
                },
                {
                    name: '版权申明',
                    routeName: 'webIntroduce',
                    active: 1
                },
                {
                    name: '广告服务',
                    routeName: 'webIntroduce',
                    active: 2
                },
                {
                    name: '人才招聘',
                    routeName: 'webIntroduce',
                    active: 3
                },
                {
                    name: '联系我们',
                    routeName: 'webIntroduce',
                    active: 4
                },
            ],
            footInfo: {}
        }
    },
    created() {
    },
    methods: {

        jump(item, index) {
            this.$router.push({
                name: item.routeName,
                query: {
                    documentTitle: item.name,
                    activeItem: JSON.stringify(item),
                    active: item.active
                }
            })
        },

        // 跳转备案网站
        toBeian() {
            // console.log(routeUrl);
            window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
        },
    }
}
</script>

<style lang="less" scoped>
.foot {
    margin: 0 auto;
    color: #fff;
    .footItem {
        width: calc(100% - 10px);
        background-color: #0449AE;
        padding: 22px 50px 22px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1430px;
        }
    }
    .top {
        /* color: #134AA6; */
        text-align: center;
        padding-bottom: 15px;
        .chunk {
            padding: 0 20px;
            cursor: pointer;
            font-size: 18px;
        }
    }
    .center {
        margin: 15px 0;
        height: 6px;
        background-color: #1A68E8;
    }
    .bottom {
        /* color: #666; */
        font-size: 14px;
        text-align: center;
    }
}
</style>
